export enum PensionManagedBy {
  Bureau = 'Bureau',
  Employer = 'Employer'
}

export const PENSION_ERROR_CODES = {
  CREDENTIALS_NOT_FOUND: 'PENSION_CREDENTIALS_NOT_FOUND'
} as const;
